<template>
    <div class="">
        <div class="form-group kt-margin-0 kt-padding-0 w-100">
            <div class="row">
                <div class="col col-sm-12 pr-0">
                    <loading2 v-if="loading"></loading2>
                    <v-select v-model="user"
                              label="text"
                              :options="users"
                              :filterable="false"
                              :placeholder="placeholder"
                              @search="onGroupSearch"
                              @search:focus="onGroupFocus"
                              @input="onGroupChange">
                        <template slot="option" slot-scope="option" v-if="option">
                            <div v-html="option.text"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="user && user.text">
                          <div v-html="user.text"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">
                                {{$t("empty")}}
                            </span>
                    </v-select>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import initFilterModel from '@/shared/filter';
    import Loading2 from "@/views/Loading2";

    export default {
        name: "UserSelect",
        components: {
            Loading2,
        },
        props: {
            placeholder: String,
            type: String,
            value: Object,
            parent: Object,
        },
        data() {
            return {
                filter: initFilterModel(),
                user: null,
                users: [],
                loading: false
            }
        },
        methods: {
            getData() {
                this.loading = true;
                const headers = {
                    'lang': localStorage.getItem('x_lang')
                };
                this.$http.post('user-list', {headers}, this.filter)
                    .then(res => {
                        this.loading = false;
                        console.log(res.data);
                        this.users = res.data.data;
                    }, err => {
                        this.loading = false;
                        console.log(err);
                    });
            },
            onGroupSearch(searchTxt) {
                this.loading = true;
                this.users = [];
                this.filter.search = searchTxt;
                this.getData();
            },
            onGroupFocus() {
                this.loading = true;
                this.users = [];
                this.filter.search = null;
                this.getData();
            },
            onGroupChange() {
                this.$emit('input', this.user);
            },

        },
        created() {

        },
        mounted() {
            // console.log(this.parentData);
            setTimeout(() => {
                // console.log("this.$props.value", this.$props.value);
                if (this.$props.value) {
                    this.user = this.$props.value;
                }
            }, 1000);

        },
    }
</script>

<style scoped>

</style>